import { render } from "./AdsListing.vue?vue&type=template&id=2a7450ae&scoped=true&ts=true"
import script from "./AdsListing.vue?vue&type=script&lang=ts"
export * from "./AdsListing.vue?vue&type=script&lang=ts"

import "./AdsListing.vue?vue&type=style&index=0&id=2a7450ae&scoped=true&lang=css"
import "./AdsListing.vue?vue&type=style&index=1&id=2a7450ae&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7450ae"]])

export default __exports__